import React, {useContext, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {isDesktop, isIOS, isMacOs} from "react-device-detect";
import CommandeAPI from "../../services/CommandeAPI";
import AuthContext from "../../contexts/AuthContext";
import AlertCustom from "../../components/ui/alert/AlertCustom";
import ExecutionsAPI from "../../services/ExecutionsAPI";
import {RefusalForm} from "../../components/pages/executions/RefusalForm";
import {useStoreExecutions} from "../../store/useStoreExecutions";
import {base64} from "../../Tools/Tools";
import {configureShoppersModals} from "../../slice/shoppersModalsSlice";
import {useStoreExecutionsAccepted} from "../../store/useStoreExecutionsAccepted";
import {TakePicture} from "../../components/ui/image/TakePicture.tsx";
import {CommentForm} from '../../components/pages/executions/CommentForm.tsx';
import {Pictures} from '../../components/pages/executions/Pictures.tsx';
import TransmissionsAPI from '../../services/TransmissionsAPI';
import {useStoreTransmissions} from '../../store/useStoreTransmissions.ts';
import {SavForm} from '../../components/pages/transmissions/SavForm.tsx';
import {createBlobUrl} from '../../Tools/File'

export const useOrders = () => {
    const {user} = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const [showModalInformation, setShowModalInformation] = useState(false);
    const [modalTitle, setModalTitle] = useState(false);
    const [modalSize, setModalSize] = useState('sm');
    const [modalBodyClass, setModalBodyClass] = useState('text-left');
    const [modalFooter, setModalFooter] = useState(true);
    const [buttons, setButtons] = useState([]);
    const getExecutions = useStoreExecutions((state) => state.getExecutions);
    const executions = useStoreExecutions((state) => state.executions);
    const dispatch = useDispatch();
    const getExecutionsAccepted = useStoreExecutionsAccepted(state => state.getExecutionsAccepted);

    const handleShowOrder = async (id) => {
        id = Array.isArray(id) ? id[0] : id;
        setIsLoading(true);
        await CommandeAPI.getPDF(id)
            .then(({data}) => {
                if (data.size === 0) {
                    setShowModalInformation(true)

                    setModalContent(
                        <AlertCustom
                            variant={'warning'}
                            heading={false}
                            bodyContent={`Il n'y a actuellement aucun élément à afficher.`}
                            transition={true}
                        />,
                    )
                } else {
                    const url = createBlobUrl(data)

                    if (isMacOs || isIOS) {
                        window.open(url, '_blank')
                    } else if (isDesktop) {
                        window.open().location = url
                    } else {
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('target', '_blank')
                        link.click()
                    }
                }
            })

        setIsLoading(false);
    }

    const handleRefusal = async (order) => {
        await ExecutionsAPI.getRefus().then(function(response) {
            if (response.data) {
                setModalTitle(`Motif de refus de la commande ${((order.item?.numcde) || order.id)}`);
                setModalContent(<RefusalForm refus={response.data} order={order} setShowModal={setShowModalInformation} setModalContent={setModalContent} />);
                setModalSize('md');
                setShowModalInformation(true);
                setButtons([
                    {
                        text: 'Enregistrer',
                        formId: 'refusalForm',
                        type: 'submit',
                    }
                ])
            }
        })
    }

    const handleState = async (order) => {
        try {
            await ExecutionsAPI.postExecutions({
                etatextranet: Number.parseInt(order.item.actions[order.id].id, 10),
                etatextranetlibelle: order.item.actions[order.id].label,
                idsgribouil: order.item.idsgribouil,
                numcde: order.item.numcde,
            }).then(() => {
                getExecutions(user, true, false);

                // Si la commande est acceptée, on recharge le tableau des commandes acceptées
                if (Number.parseInt(order.item.actions[order.id].id, 10) === 4) {
                    getExecutionsAccepted(user, true);
                }
            });
        } catch (error) {
            setModalContent((
                <AlertCustom
                    variant={'danger'}
                    heading={true}
                    bodyContent={error.response.data.detail}
                    transition={true}
                />
            ));
        }

    }

    function handleStateWithComment(order) {
        setModalTitle('Donnez nous plus de détails');
        setModalContent(<CommentForm order={order} setShowModal={setShowModalInformation} setModalContent={setModalContent} />);
        setModalSize('md');
        setShowModalInformation(true);
        setModalFooter(false);
    }

    const handleViewPic = async (order) => {
        setModalContent(<Pictures pictures={order.item.pictures} />);
        setShowModalInformation(true);
        setModalSize('lg');
    }

    useEffect(() => {
        if (executions.length) {
            const chosenPrebooks = {}

            executions.forEach((execution) => {
                if (execution.prebook?.mission) {
                    chosenPrebooks[base64(execution.prebook.id)] = execution.prebook
                }
            })

            dispatch(configureShoppersModals({chosenPrebooks}))
        }
    }, [executions])

    const handleTakePic = (order) => {
        setModalContent(<TakePicture order={order} onHide={setShowModalInformation} />);
        setShowModalInformation(true);
        setModalSize('lg');
        setModalBodyClass('text-center')
        setModalFooter(false);
    }

    function handleDeleteOrder(order) {
        setModalContent(<h3>Etes-vous sûr de vouloir supprimer cette commande ?</h3>);
        setShowModalInformation(true);
        setModalSize('sm');
        setButtons([
            {
                text: 'Confirmer',
                func: () => deleteOrder(order),
                classNames: 'mx-2',
            },
        ])
    }

    async function deleteOrder(order) {
        setIsLoading(true);
        await TransmissionsAPI.deleteTransmissions(order.idsenattente)
            .then(() => {
                const fetchTransmissions = useStoreTransmissions(state => state.fetchTransmissions);
                setIsLoading(false);
                setButtons([]);
                setModalContent(
                    <AlertCustom
                        classname="text-left"
                        variant={'sucess'}
                        heading={true}
                        headingTitle={'Bravo !'}
                        headingIconName={'info-circle'}
                        bodyContent={'Votre commande a bien été supprimée.'}
                        transition={true}
                    />,
                );
                fetchTransmissions(true);
            })
            .catch(() => {
                setModalContent(
                    <AlertCustom
                        classname="text-left"
                        variant={'danger'}
                        heading={true}
                        bodyContent={
                            "Votre commande n'a pas pu être supprimée, veuillez réessayer ultérieurement."
                        }
                        transition={true}
                    />,
                )
            });
    }

    function handleViewSav(sav) {
        setModalContent(
            <SavForm
                sav={sav}
                setShowModal={setShowModalInformation}
                setModalContent={setModalContent}
            />,
        )
        setModalSize('lg');
        setShowModalInformation(true);
        setButtons([
            {
                text: 'Enregistrer',
                formId: 'savForm',
                type: 'submit',
            },
        ])
    }

    return {
        handleShowOrder,
        handleRefusal,
        handleState,
        handleStateWithComment,
        handleViewPic,
        handleTakePic,
        handleDeleteOrder,
        handleViewSav,
        isLoading,
        modalContent,
        showModalInformation,
        setShowModalInformation,
        modalTitle,
        modalSize,
        modalBodyClass,
        modalFooter,
        buttons
    }
}
